import { GQLFlipTilesFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { PromoImageContainer } from '@theprintbar/ui';
import { FlipTile } from './FlipTile';

interface FlipTilesProps {
	content: GQLFlipTilesFragment;
	className?: string;
}

export function FlipTiles({ content, className }: FlipTilesProps) {
	let tiles = content.flipTiles.structure;
	if (!tiles?.length) return null;

	//If there's a promo image we only take the first 4 tiles
	if (content.flipTilePromoImage) {
		tiles = tiles.slice(0, 4);
	}

	return (
		<div className={cn('grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-10 grid-flow-row mt-4', className)}>
			{!!content.flipTilePromoImage && (
				<div className="hidden lg:block col-start-3 row-start-1 row-span-2">
					<PromoImageContainer
						promoImage={content.flipTilePromoImage}
						className="w-full h-full rounded-3xl border border-blue overflow-hidden"
						promoPosition="left"
					/>
				</div>
			)}
			{tiles.map((tile, index) => (
				<div key={index} className="flex flex-col w-full">
					<FlipTile key={index} tile={tile} />
				</div>
			))}
		</div>
	);
}
